import graphql__97e145c6a6c50b11dbec from "./__generated__/MapFilterTaxonomyFilterWithoutChildren_mapTaxonomy.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";

import MapFilterTaxonomySelector from "./MapFilterTaxonomySelector";

const MapFilterTaxonomyFilterWithoutChildren = props => {
  const mapTaxonomy = useFragment(
    MapFilterTaxonomyFilterWithoutChildren_mapTaxonomy,
    props.mapTaxonomy
  );
  const { filterId, initiallyActive, onFilterSelectorClicked } = props;

  // Only the taxonomy id is passed back, as Relay masks the fields this component's own
  // fragment doesn't declare : the filter resolves it against the taxonomies it holds.
  const handleSelectorClicked = useCallback(() => {
    onFilterSelectorClicked(mapTaxonomy.id);
  }, [onFilterSelectorClicked, mapTaxonomy.id]);

  return (
    <div key={mapTaxonomy.id}>
      <MapFilterTaxonomySelector
        filterId={filterId}
        initiallyActive={initiallyActive}
        mapTaxonomy={mapTaxonomy}
        onClick={handleSelectorClicked}
      />
    </div>
  );
};

const MapFilterTaxonomyFilterWithoutChildren_mapTaxonomy = graphql__97e145c6a6c50b11dbec;

export default MapFilterTaxonomyFilterWithoutChildren;
